import { render, staticRenderFns } from "./XgPsw.vue?vue&type=template&id=730aa95a&scoped=true&"
import script from "./XgPsw.vue?vue&type=script&lang=js&"
export * from "./XgPsw.vue?vue&type=script&lang=js&"
import style0 from "./XgPsw.vue?vue&type=style&index=0&id=730aa95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730aa95a",
  null
  
)

export default component.exports